export const accordionSizes = {
  s: 's',
  l: 'l',
}

export const accordionGapsRem = {
  [accordionSizes.s]: '0.75rem',
  [accordionSizes.l]: '0',
}

export const accordionGapsPx = {
  [accordionSizes.s]: '12px',
  [accordionSizes.l]: '0',
}

export const accordionItemTitlePaddingsRem = {
  [accordionSizes.s]: '0.25rem 0',
  [accordionSizes.l]: '1.375rem 0',
}

export const accordionItemTitlePaddingsPx = {
  [accordionSizes.s]: '0',
  [accordionSizes.l]: '22px 0',
}

export const accordionItemTitleTextSizesDesktop = {
  [accordionSizes.s]: 'pM',
  [accordionSizes.l]: 'h6',
} as const

export const accordionItemTitleTextSizesMobile = {
  [accordionSizes.s]: 'pM',
  [accordionSizes.l]: 'pL',
} as const

export const accordionItemContentTextSizesDesktop = {
  [accordionSizes.s]: 'pM',
  [accordionSizes.l]: 'pL',
} as const

export const accordionItemContentTextSizesMobile = {
  [accordionSizes.s]: 'pM',
  [accordionSizes.l]: 'pM',
} as const

export const accordionItemIconWrapperSizesRem = {
  [accordionSizes.s]: '2rem',
  [accordionSizes.l]: '2.5rem',
}

export const accordionItemIconWrapperSizesPx = {
  [accordionSizes.s]: '32px',
  [accordionSizes.l]: '40px',
}

export const accordionItemIconSizesRem = {
  [accordionSizes.s]: {
    width: '1rem',
    height: '1rem',
  },
  [accordionSizes.l]: {
    width: '1rem',
    height: '1rem',
  },
}

export const accordionItemIconSizesPx = {
  [accordionSizes.s]: {
    height: '15px',
    width: '15px',
  },
  [accordionSizes.l]: {
    height: '15px',
    width: '15px',
  },
}

export const accordionItemContentMarginBottomOpenRem = {
  [accordionSizes.s]: '1rem',
  [accordionSizes.l]: '1rem',
}

export const accordionItemContentMarginBottomOpenPx = {
  [accordionSizes.s]: '16px',
  [accordionSizes.l]: '16px',
}
